import type { MoneyMapAccountWithAccountDetails } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useGetMembershipMoneyMapAccounts = requestBuilder.query<
    MoneyMapAccountWithAccountDetails[]
>({
    endpoint: '/api/money-map/accounts',
    queryKey: 'getMembershipMoneyMapAccounts',
});
